import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  ViewChildren,
  QueryList
} from '@angular/core';
import {UploadService} from '../services/upload.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DomSanitizer} from '@angular/platform-browser';
import {SentenceServiceService} from '../services/sentence-service.service';
import { MetricsService } from '../services/metrics.service';

declare let MediaRecorder: any;


@Component({
  selector: 'app-voice-recorder',
  templateUrl: './voice-recorder.component.html',
  styleUrls: ['./voice-recorder.component.scss']
})
export class VoiceRecorderComponent implements OnInit, AfterViewInit, OnDestroy {
  // @ViewChildren('audio') audio: QueryList<'audio'>;
  @ViewChild('audio') audio: ElementRef;

  counter: number;
  timerRef;
  running = false;

  hours;
  minutes;
  seconds;

  files: any[] = [];
  file;

  chunks: any[] = [];
  mediaRecorder;
  recording = false;
  recordPaused = false;
  audioType = 'audio/wav';
  audiosUrl = [];
  sentence = {id: '', sentence: ''};
  uploadCount: number;
  totalRecording;

  constructor(private uploadService: UploadService,
              private snackBar: MatSnackBar,
              private sanitizer: DomSanitizer,
              private sentenceService: SentenceServiceService,
              private metric: MetricsService,
              ) {

    this.sentenceService.getRandomSentence().subscribe(sentence => {
      this.sentence = sentence;
    });

    
  }

  ngOnInit(): void {
    this.uploadCount = 0;

     //total recordings
     this.metric.getTotalRecording().subscribe((recordings: any) => {
      this.totalRecording = recordings[0].count;
    });
  }

  async ngAfterViewInit(): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({audio: true});
    this.mediaRecorder = new MediaRecorder(stream, {
      // mimeType: this.audioType
    });
    // this.audio.sourceObject = stream

    this.mediaRecorder.ondataavailable = event => {
      if (event.data && event.data.size > 0) {
        this.chunks.push(event.data);
      }
    };
  }

  randomSentence(): void {
    this.sentenceService.getRandomSentence().subscribe(sentence => {
      this.sentence = sentence;
    });
  }

  startRecording(): void {
    this.chunks = [];
    this.mediaRecorder.start(10);
    this.recording = true;
    this.startTimer();
  }

  pauseRecording(): void {
    this.startTimer();
    if (this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.pause();
      this.recordPaused = true;
    } else if (this.mediaRecorder.state === 'paused') {
      this.mediaRecorder.resume();
      this.recordPaused = false;
    }
  }

  stopRecording(): void {
    this.mediaRecorder.stop();
    this.recording = false;
    this.recordPaused = false;
    this.saveAudio();
    this.stopTimer();
  }

  saveAudio(): void {
    const blob = new Blob(this.chunks, {type: 'audio/wav'});
    const audioURL = window.URL.createObjectURL(blob);
    this.file = new File([blob], `REC${Date.now()}.wav`, {type: 'audio/wav', lastModified: Date.now()});
    this.file.progress = 0;
    this.file.url = this.sanitizer.bypassSecurityTrustResourceUrl(audioURL);
    this.files.push(this.file);
    console.log(this.file);
  }

  startTimer(): void {
    this.running = !this.running;
    if (this.running) {
      const startTime = Date.now() - (this.counter || 0);
      this.timerRef = setInterval(() => {
        this.counter = Date.now() - startTime;

        // Convert counter to different time formats
        this.hours = Math.floor((this.counter % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((this.counter % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((this.counter % (1000 * 60)) / 1000);

        // Add '0' to the time when less than 10
        this.hours = (this.hours < 10) ? '0' + this.hours : this.hours;
        this.minutes = (this.minutes < 10) ? '0' + this.minutes : this.minutes;
        this.seconds = (this.seconds < 10) ? '0' + this.seconds : this.seconds;
      }, 1000);
    } else {
      clearInterval(this.timerRef);
    }
  }

  pauseTimer(): void {
    clearInterval(this.timerRef);
  }

  stopTimer(): void {
    this.running = false;
    this.counter = undefined;
    clearInterval(this.timerRef);
  }

  sendFile(file): void {
    const path = `${Date.now()}_${file.name}`;
    // file.name = path;
    this.uploadService.uploadFile(path, file, this.sentence).subscribe(snapshot => {
      file.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      if (file.progress === 100){
        this.files = [];
        this.randomSentence();
        this.uploadCount += 1;
        this.totalRecording += 1
        this.snackBar.open('Upload Complete. You can now record again.', '', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    });
  }

  // Convert the file size
  formatBytes(bytes, decimals): any {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  clearRecording(): void{
    this.chunks = [];
    this.recording = false;
    this.recordPaused = false;
    this.files = [];
  }

  ngOnDestroy(): void {
    clearInterval(this.timerRef);
  }
}
